module.exports = __webpack_public_path__ + "static/media/01.bd094084.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Home/01.png
// module id = 198
// module chunks = 10